import { atom } from '~/observers/jotai'

import { IlistPersonalTrainerDTO } from './types'

export const personalTrainersAtom = atom<IlistPersonalTrainerDTO>({
  meta: { page: 0, perPage: 10, totalPages: 0 },
  personalTrainers: [],
})
